import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataMatricula = (): TabelaColuna => ({
  Chave: 'dataMatricula',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataMatricula)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Data Matrícula</div>
})
